document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.footer-toggle');
  toggles.forEach(button => {
    button.addEventListener('click', () => {
      button.parentElement.classList.toggle('active');
    });
  });
});
